<template>
  <div>
    <Board>
      <template #main>
        <BaseTitle class="d-block mb-4" v-text="$tc('campaign.record', 1)" />
        <BaseParagraph
          class="d-block mb-1"
          v-text="$t('campaign.records.description')"
        />
        <BaseParagraph
          v-text="
            $t('campaign.records.agreedRecords', {
              count: recordsAgreed.count,
            })
          "
        />
        <CampaignDetailRecordsList
          :list-headers="recordsHeaders"
          :records="recordsAgreed.items"
          :record-status="'AGREED'"
          :records-count="recordsAgreed.count"
          :is-loading-records="recordsAgreed.loading"
          @update-filters="updateFilters($event, 'AGREED')"
        />
        <BaseExpensionPanels class="my-4" multiple>
          <BaseExpensionPanel
            :disabled="
              recordsInProgress.loading || recordsInProgress.count === 0
            "
            class="in-progress-panel"
            expand
            eager
          >
            <template slot="header">
              <v-skeleton-loader
                v-if="recordsInProgress.loading"
                class="skeleton"
                type="text"
              />
              <BaseParagraph
                v-else
                color="accent"
                v-text="
                  $t('campaign.records.inProgressRecords', {
                    count: recordsInProgress.count,
                  })
                "
              />
            </template>
            <template slot="content">
              <CampaignDetailRecordsList
                :list-headers="recordsHeaders"
                :records="recordsInProgress.items"
                :records-count="recordsInProgress.count"
                :record-status="'IN_PROGRESS'"
                :is-loading-records="recordsInProgress.loading"
                @update-filters="updateFilters($event, 'IN_PROGRESS')"
              />
            </template>
          </BaseExpensionPanel>
        </BaseExpensionPanels>
      </template>
    </Board>
    <RelaunchInvitationRecordDialog :reminders="campaign.recordsInProgress" />
  </div>
</template>

<script>
import Board from "@/core/Components/Board";
import CampaignDetailRecordsList from "../Components/CampaignDetailRecordsList";

import RelaunchInvitationRecordDialog from "../../Folder/Components/RelaunchInvitationRecordDialog.vue";

export default {
  name: "CampaignDetailRecords",
  components: {
    Board,
    CampaignDetailRecordsList,
    RelaunchInvitationRecordDialog,
  },
  props: {
    isFetchingActiveCampaign: {
      type: Boolean,
      required: true,
    },
    campaign: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      recordsHeaders: [
        {
          text: this.$tc("organization.client", 1),
          value: "user.email",
          sort: (a, b) => a.localeCompare(b),
        },
        {
          text: `${this.$tc("utils.date", 1)}`,
          value: "dateCreated",
          sort: (a, b) => a - b,
        },
        {
          text: `${this.$t("utils.dateRelaunch")}`,
          value: "dateCreated",
          sort: (a, b) => a - b,
        },
        {
          value: "data-table-expand",
        },
      ],
      recordsAgreed: {
        items: [],
        count: 0,
        page: 1,
        pageSize: 10,
        next: null,
        loading: false,
      },
      recordsInProgress: {
        items: [],
        count: 0,
        page: 1,
        pageSize: 10,
        next: null,
        loading: false,
      },
    };
  },
  created: function () {
    this.initialize();
  },
  methods: {
    updateFilters(filters, status) {
      if (status === "AGREED") {
        this.recordsAgreed = {
          ...this.recordsAgreed,
          ...filters,
          loading: true,
        };
        return this.fetchRecordsAgreed();
      }
      this.recordsInProgress = {
        ...this.recordsInProgress,
        ...filters,
        loading: true,
      };
      this.fetchRecordsInProgress();
    },
    async fetchRecordsAgreed() {
      const res = await this.$store.dispatch(
        "course/fetchOrganizationCourseCampaignRecordsAgreed",
        {
          organizationId: this.$route.params.organizationId,
          campaignId: this.$route.params.campaignId,
          page: this.recordsAgreed.page,
          pageSize: this.recordsAgreed.pageSize,
        }
      );
      this.recordsAgreed = {
        ...this.recordsAgreed,
        items: res.data.results,
        count: res.data.count,
        next: res.data.next,
        loading: false,
      };
    },
    async fetchRecordsInProgress() {
      this.recordsInProgress.loading = true;
      const res = await this.$store.dispatch(
        "course/fetchOrganizationCourseCampaignRecordsInProgress",
        {
          organizationId: this.$route.params.organizationId,
          campaignId: this.$route.params.campaignId,
          page: this.recordsInProgress.page,
          pageSize: this.recordsInProgress.pageSize,
        }
      );
      this.recordsInProgress = {
        ...this.recordsInProgress,
        items: res.data.results,
        count: res.data.count,
        next: res.data.next,
        loading: false,
      };
    },
    async initialize() {
      Promise.all([this.fetchRecordsAgreed(), this.fetchRecordsInProgress()]);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .disagreed-panel {
  background-color: #fef9fa !important;
}
::v-deep .disagreed-panel .v-expansion-panel-content {
  background-color: white;
}

::v-deep .in-progress-panel {
  background-color: #e6d6ff !important;
}
::v-deep .in-progress-panel .v-expansion-panel-content {
  background-color: white;
}
.skeleton {
  height: 17px;
  width: 100%;
  ::v-deep {
    .v-skeleton-loader__bone {
      height: 17px;
    }
  }
}
</style>
